import { render } from "./GuessingGame.vue?vue&type=template&id=27b77a38&scoped=true&ts=true"
import script from "./GuessingGame.vue?vue&type=script&lang=ts"
export * from "./GuessingGame.vue?vue&type=script&lang=ts"

import "./GuessingGame.vue?vue&type=style&index=0&id=27b77a38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b77a38"]])

export default __exports__